module.exports = __webpack_public_path__ + "static/media/overlay-color@3x.afe49456.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/WorkoutPlanBackgrounds/bg14/overlay-color@3x.png
// module id = 1244
// module chunks = 2